(() => {
  const initialise = (root = document) => {
    const headers = [];
    if (root.matches?.('[data-h7-liquid-nav]')) headers.push(root);
    headers.push(...root.querySelectorAll('[data-h7-liquid-nav]'));

    headers.forEach((header) => {
      if (header.dataset.h7LiquidNavReady === 'true') return;
      header.dataset.h7LiquidNavReady = 'true';

      const controller = new AbortController();
      const { signal } = controller;
      let frame = 0;
      const navShell = header.querySelector('.header');
      const syncMenuMode = () => {
        if (window.matchMedia('(max-width: 989px)').matches) {
          header.classList.add('is-menu-collapsed');
          return;
        }

        header.classList.remove('is-menu-collapsed');
      };

      const update = () => {
        frame = 0;
        const scrolled = window.scrollY > 16;
        header.classList.toggle('is-scrolled', scrolled);
        document.documentElement.classList.toggle('h7-nav-is-scrolled', scrolled);
        syncMenuMode();
      };
      const scheduleUpdate = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', scheduleUpdate, { passive: true, signal });
      window.addEventListener('resize', scheduleUpdate, { passive: true, signal });
      document.fonts?.ready.then(() => {
        if (!signal.aborted) scheduleUpdate();
      });

      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(header)) return;
        if (frame) window.cancelAnimationFrame(frame);
        controller.abort();
        document.documentElement.classList.remove('h7-nav-is-scrolled');
        header.classList.remove('is-menu-collapsed');
        delete header.dataset.h7LiquidNavReady;
      }, { signal });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
